import { render } from "./Asset_Documents.vue?vue&type=template&id=1d86e7dd"
import script from "./Asset_Documents.vue?vue&type=script&lang=js"
export * from "./Asset_Documents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__